import { Injectable } from '@angular/core';
import { Role } from '@sisem/sisem-actors-types';
import {
  KnownPermissions,
  KnownRoles,
  KnownSections,
  MappedLandingRoutes,
  MappedPermissions,
  MappedSectionsRoles,
} from './Validation';
import { ProfileService } from '../profile/profile.service';
import { NavItem } from '../../types/known-routes/general.known.routes';

@Injectable({
  providedIn: 'root',
})
export class RoleValidatorService {
  private _lastLandingFetch: NavItem | undefined;
  private _lastLandingFetchCount = 0;
  private _changeModule = false;

  public get lastLandingFetch() {
    return this._lastLandingFetch;
  }

  public get lastLandingFetchCount() {
    return this._lastLandingFetchCount;
  }

  public get changeModule() {
    return this._changeModule;
  }

  public set changeModule(status) {
    this._changeModule = status;
  }

  public resetLastLanding() {
    this._lastLandingFetchCount = 0;
    this._lastLandingFetch = undefined;
  }

  constructor(private profileService: ProfileService) {}

  async hasPermission(roles: Role[], permission: KnownPermissions): Promise<boolean> {
    if (!roles.length) {
      return false;
    }
    const fullRoles = await this.profileService.getRoles();
    for (const role of roles) {
      if (!role) {
        continue;
      }
      const fullRole = fullRoles.find((value) => value.id === role.id);
      if (!fullRole) {
        console.error(`Role with id ${role.id} could not be found`);
        continue;
      }
      if (fullRole.permissions === undefined) {
        console.error(
          'Role without permissions relation, must manually fetch role with fixed permissions'
        );
        continue;
      }
      const mappedPermission = MappedPermissions[permission];
      const result = fullRole.permissions.find((value) =>
        /*value.keycloakClientRoleName === mappedPermission.keycloakClientRoleName &&
          value.keycloakClientId === mappedPermission.keycloakClientId*/
        {
          return (
            mappedPermission.keycloakClientRoleName.includes(value.keycloakClientRoleName) &&
            mappedPermission.keycloakClientId.includes(value.keycloakClientId)
          );
        }
      );
      if (result) {
        return true;
      }
    }
    return false;
  }

  /**
   * Return defaults path for Known roles, useful in case of route fallbacks
   * @param role
   * Return route as string
   */
  public getLandingRoute(role: KnownRoles): NavItem {
    let landing = MappedLandingRoutes[role];
    if (!this._lastLandingFetch || this._lastLandingFetch !== landing) {
      this._lastLandingFetchCount = 0;
    }
    if (!landing) {
      landing = {
        route: '',
        iconName: '',
        displayName: '',
        id: -1,
      };
    }
    this._lastLandingFetch = landing;
    this._lastLandingFetchCount++;
    return landing;
  }

  public hasAccessToSection(section: KnownSections, role: KnownRoles): boolean {
    return MappedSectionsRoles[section]?.includes(role) || false;
  }
}
